import qs from 'qs';
import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { EReports, IDefect, IPosition, IRealEstate } from './interfaces';

export const getGroupApplicationReportList = (report: EReports, config?: AxiosRequestConfig) => {
  return instance()
    .get(`/applicationGroup/${report}/report`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

export const exportGroupApplicationReportExcel = (report: EReports, config?: AxiosRequestConfig) => {
  return instance()
    .get(`/applicationGroup/${report}/report/excel`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

export const getPositions = () => {
  return instance()
    .post<IPosition[]>('/dictionary/positions', {})
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { searchWithCity?: boolean; nameWithCity?: boolean } = {
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};

export const getDefectsShort = () => {
  return instance()
    .post<IDefect[]>('/dictionary/defectsByPositionShort', {})
    .then((response) => response.data);
};
